module.exports = require('react/lib/cloneWithProps');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-clone-with-props/index.js
// module id = 91
// module chunks = 0